import React, { Component } from 'react';
import { translate } from 'react-i18next';
// import axios from 'axios';
// import moment from 'moment-timezone';
import brandLogo from '../../images/brand-logo-dark.png';
import * as $ from 'jquery';

class ExtendBookModal extends Component {
    componentWillUnMount() {
        // alert('unmount')
        this.props.handleExtendBook();
        const backdrop = document.querySelector(".modal-backdrop");
        // elimina todos los elementos
        if (backdrop) {
            backdrop.remove();
        }
    }
    componentDidMount() {
        $('#btnExtendBook').click();
        $('#modalSuccess').on('hidden.bs.modal', () => {
            // console.log('El modal se cerró/dismiss');
            // Puedes realizar acciones adicionales después de que el modal se cierra
            this.props.handleExtendBook();
        });
    }
    render() {
        // const { t } = this.props;
        return (
            <div>
                <button
                    className="hidden"
                    data-target="#modalSuccess"
                    data-toggle="modal"
                    id="btnExtendBook"
                    type="button">
                </button>
                <div className="modal fade" id="modalSuccess" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header COVID-HEADER">
                                <button type="button" className="close btn-primary" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" style={{ fontSize: '30px', background: 'red', width: '30px', display: 'block' }}>&times;</span></button>
                                <div className="navbar-header">
                                    <div className="navbar-brand">
                                        <img alt="IOS OFFICES" className="brand-logo" src={brandLogo} />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-body">
                                <h3>Nueva Reservación</h3>
                                <div className="card-panel-body">
                                    <div className="form-group card-panel panel panel-default card center-block" style={{ display: 'block', padding: '10px' }}>
                                        <h5 className="iossala">Extender Reserva</h5>

                                        <div className="panel-description-text">
                                            Su pre-reservación está a punto de expirar, ¿Desea extenderla?
                                        </div>
                                        {/* <div className="contenedor">
                                            <i className="fa fa-calendar" aria-hidden="true"></i>
                                            &ensp;
                                            Mundo
                                        </div> */}
                                        {/* {duration === '4' ? (
                                            "Precio de Sala por 2 Horas $" + room.hrs_2
                                        ) : (
                                            duration === '8' ? (
                                                "Precio de Sala por 4 Horas $" + room.hrs_4
                                            ) : (
                                                "Precio de Sala por un dia Completo $" + room.full_day
                                            )
                                        )} */}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer panel-body-bottom">
                                {/* <button
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                    style={{ background: "#FFF", border: "1px solid #3CC", color: "#3CC" }}
                                    type="button">
                                    Cancelar
                                </button> */}
                                <button
                                    className="btn btn-primary"
                                    data-dismiss="modal"
                                    style={{ background: "#33CCCC", border: "1px solid #33CCCC" }}
                                    onClick={this.props.handleExtendBook}
                                    type="button">
                                    Extender Reserva
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('common')(ExtendBookModal);


// WEBPACK FOOTER //
// ./src/store/Reservation/ExtendBookModal.js